import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { QuestionType } from '../../../../../form';
import { BaseQuestionSwitchStrategy } from './base.strategy';
/**
 * Strategy: Essay → Other Types
 * Rule 5: Essay → Any inits default answers
 */

export var EssaySwitchStrategy = /*#__PURE__*/function (_BaseQuestionSwitchSt) {
  _inherits(EssaySwitchStrategy, _BaseQuestionSwitchSt);

  var _super = _createSuper(EssaySwitchStrategy);

  function EssaySwitchStrategy() {
    _classCallCheck(this, EssaySwitchStrategy);

    return _super.call(this, QuestionType.Essay);
  }

  _createClass(EssaySwitchStrategy, [{
    key: "canHandle",
    value: function canHandle(toType) {
      return this.fromType === QuestionType.Essay;
    }
  }, {
    key: "execute",
    value: function execute(toType) {
      // Rule 5: Essay → Any type needs to initialize default answers
      switch (toType) {
        case QuestionType.SingleChoice:
        case QuestionType.MultipleChoice:
        case QuestionType.FillInBlank:
        case QuestionType.Matching:
          return {
            shouldPreserveAnswers: false,
            shouldPreserveDescription: true,
            shouldResetToDefault: true,
            shouldClearAnswers: false,
            strategyName: "Essay \u2192 ".concat(toType, ": Initialize default answers")
          };

        default:
          return {
            shouldPreserveAnswers: false,
            shouldPreserveDescription: true,
            shouldResetToDefault: true,
            shouldClearAnswers: false,
            strategyName: "Essay \u2192 ".concat(toType, ": Default behavior")
          };
      }
    }
  }]);

  return EssaySwitchStrategy;
}(BaseQuestionSwitchStrategy);